import { ExamplesTable } from './tutorials/LoadSampleData';
import { WhoAreWe } from './WhoAreWe.jsx';

import {ReactComponent as Figure} from './docs/results.svg';

const name = 'Fatty Acylizer';

export const DefaultPage = ({setToken, setPage}) => (
  <div className="doc-container">
    <h2>
      Hello and welcome to <strong>{name}</strong>!
    </h2>
    <Figure />
    <p>
      {name} reconstructs missing fatty acid information that underlie complex lipid profiles using a combinatorial side chain substitution model.
    </p>
    <h2>Getting Started</h2>
    <div className="row row-cols-1 row-cols-md-3 g-4">
      <div className="col">
        <div className="card h-100">
          <div className="card-body">
            <h5 className="card-title">Get familiar</h5>
            <p className="card-text">
              with the user interface of {name} by:
              <ul>
                <li>loading one of many provided <a href="#example-table">example data sets</a></li>
                <li>
                  watching our <a href="https://youtu.be/vnQddmMYAsc?si=jhtxjWesau1nt5J9">walk-through video</a>
                  <iframe
                    width="100%" style={{aspectRatio: 16/9}}
                    src="https://www.youtube.com/embed/vnQddmMYAsc?si=RpMr0YBexTK7map8" 
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="card h-100">
          <div className="card-body">
            <h5 className="card-title">Get started</h5>
            <p className="card-text">
              uploading, reconstructing and analyzing your own data with:
              <ul>
                <li>our <a href="#" onClick={() => setPage("tutorial")}>written tutorials</a></li>
                <li>
                  our <a href="https://youtube.com/playlist?list=PLrYiE9ZA4RSIFLLs6b7Nob2tVPqzDG1eK&si=SrmFKShrEjerVR_A">video tutorials</a>
                  <iframe
                    width="100%" style={{aspectRatio: 16/9}}
                    src="https://www.youtube.com/embed/videoseries?si=SUOugz9UOpQJ0xVH&amp;list=PLrYiE9ZA4RSIFLLs6b7Nob2tVPqzDG1eK"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      <div className="col">
        <div className="card h-100">
          <div className="card-body">
            <h5 className="card-title">Dive deep</h5>
            <p className="card-text">
              into {name} with our <a href="#" onClick={() => setPage("documentation")}>documentation</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <section id="example-table">
      <h3>Example data sets</h3>
      <ExamplesTable setToken={setToken}/>
    </section>
    <WhoAreWe />
  </div>
)
